/**
 * Info listings carry no price and no condition. Used by feed cards to hide
 * those, since legacy Info rows may still hold a stale price/condition.
 * Accepts the raw id ("info"), the label ("Info") and any casing.
 */
export function isInfoListingType(listingType: string | undefined | null): boolean {
  return (listingType ?? "").trim().toLowerCase() === "info";
}
